export default __webpack_public_path__ + "static/media/autodesk-icon.bcdecdd7.png";